<template>
    <el-form
        :model="form"
        :rules="rules"
        ref="ruleForm"
        label-width="135px"
        size="small">
        <!-- 支援中心选择 -->
        <el-form-item
            :label="$t('message.ccall.form1')"
            prop="user_id">
            <el-select
                v-model="form.user_id">
                <el-option
                    v-for="(item, index) in call_user"
                    :key="index"
                    :label="item.username"
                    :value="item.id">
                </el-option>
            </el-select>
        </el-form-item>
        <!-- 申请金额 -->
        <el-form-item
            :label="$t('message.ccall.form2')"
            prop="amount">
            <el-input
                v-model="form.amount"
                class="center_call_form_input"
                clearable>
            </el-input>
        </el-form-item>
        <!-- 备注 -->
        <el-form-item
            :label="$t('message.ccall.form3')"
            prop="member_remark">
            <el-input
                v-model="form.member_remark"
                class="center_call_form_input"
                clearable>
            </el-input>
        </el-form-item>
        <!-- 提交申请 -->
        <el-form
            label-width="135px"
            size="mini">
            <el-form-item>
                <el-button
                    type="primary"
                    @click="handleSubmit('ruleForm')">
                    <span>{{$t("public.submitBtn")}}</span>
                </el-button>
            </el-form-item>
        </el-form>
    </el-form>
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
    data() {
        return {
            form: {
                user_id: "",
                amount: "",
                member_remark: ""
            },
            rules: {
                user_id: [
                    { required: true, message: this.$t("message.ccall.rule1"), trigger: 'blur' }
                ],
                amount: [
                    { required: true, message: this.$t("message.ccall.rule2"), trigger: 'blur' }
                ],
                member_remark: [
                    { required: true, message: this.$t("message.ccall.rule3"), trigger: 'blur' }
                ],
            }
        }
    },
    computed: mapState({
        call_user: state => state.call.call_user
    }),
    methods: {
        ...mapActions([
            "handleSubmitApply",
            "getCallcenterList"
        ]),
        handleSubmit(rule){
            this.$refs[rule].validate((valid) => {
                if (valid) {
                    let form = this.form;
                    this.handleSubmitApply({
                        user_id: form.user_id,
                        amount: form.amount,
                        member_remark: form.member_remark
                    }).then((res) => {
                        if(res.type){
                            this.$message({
                                showClose: true,
                                message: this.$t("message.ccall.succmsg2"),
                                type: "success"
                            })
                            this.getCallcenterList();
                        }
                    })
                } else {
                    return false
                }
            })
        }
    },
}
</script>

<style>
.center_call_form_input{
    width: 200px;
}
</style>
